import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Paper';
import ProgressBar from "../Simple/ProgressBar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const styles = theme => ({
    root: {
        width: '100%',
        overflowX: 'auto',
        marginBottom: 16,
    },
    table: {},
    tableCell: {
        padding: '0 32px 0 0',
    },
    smallInfo: {
        textTransform: 'uppercase',
        letterSpacing: 1,
        color: 'grey',
        marginLeft: 6,
    },
    rotateIcon: {
        transform: 'rotate(90deg)',
        marginLeft: 16,
        color: 'grey',
        marginRight: 6,
    },
    selectedOption: {
        fontSize: '0.7rem',
        color: 'grey',
        marginRight: 8,
    },
    selectedValue: {
        marginRight: 16,
    },
    selectedWrapper: {
        paddingRight: 16,
    },
    doubleBorderBottom: {
        borderBottomWidth: 2,
    },
    tableIconRight: {
        marginLeft: 8,
        marginRight: 6,
        float: 'right',
        marginTop: 2,
        cursor: 'pointer',
    },
    lastRowCell: {
        borderTop: '2px solid #e0e0e0'
    },
    tooltipWrappper: {
        textAlign: 'center',
    },
    loadingSpinner: {
        color: theme.palette.primary[500]
    },
});


class DashboardSegmentBehaviourTable extends PureComponent {
    state = {};

    render() {
        const {classes, data, isLoading, removeSegment} = this.props;

        return (<>
                <Paper className={classes.root}>
                    {isLoading &&
                    <div className={classes.tooltipWrappper}>
                        <Tooltip title="Updating">
                            <IconButton aria-label="Updating">
                                <FontAwesomeIcon size="xs" icon={['fal', 'spinner-third']} spin
                                                 className={classes.loadingSpinner}/>
                            </IconButton>
                        </Tooltip>
                    </div>
                    }
                    {!isLoading && data &&
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>Segmentti</TableCell>
                                {data.header.map((value, key) => {
                                    return (
                                        <TableCell align="left" classes={{root: classes.tableCell}}>{value.name}
                                            <FontAwesomeIcon icon={['fal', 'trash']} onClick={() => removeSegment(key)}
                                                             className={classes.tableIconRight}/></TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow key="0">
                                <TableCell component="th" scope="row">
                                    Käynnit <small>/ palaavat</small>
                                </TableCell>
                                {data.visitors.map((value, key) => {
                                    return (
                                        <TableCell align="left"
                                                   classes={{root: classes.tableCell}}><b>{value.visitorSessionCount}</b>
                                            <small
                                                className={classes.smallInfo}>{value.returningVisitorCount}</small></TableCell>
                                    )
                                })}
                            </TableRow>
                            {data.funnel.map((step, key) => (
                                <TableRow key={key}>
                                    <TableCell component="th" scope="row">
                                        {step.label}
                                    </TableCell>
                                    {step.values.map((value, key2) => {
                                        return (
                                            <TableCell align="left" classes={{root: classes.tableCell}}><ProgressBar
                                                value={value.left} description={value.visitorSessionCount}
                                                secondaryValue={-value.bounced}
                                                color={key === 0 ? 'orange' : 'blue'}/></TableCell>
                                        )
                                    })}
                                </TableRow>
                            ))}
                            {data.products.map((product, key) => (
                                product.rows.map((row, key) => (
                                    <TableRow key="0">
                                        <TableCell component="th" scope="row">
                                            {row.type === 'main' && <>
                                                {row.label}
                                                {row.icon && <FontAwesomeIcon size="xs" icon={['fal', 'magic']}
                                                                              style={{marginLeft: 6}}/>}
                                            </>}
                                            {row.type === 'sub' && <>
                                                <FontAwesomeIcon size={'lg'} icon={['fal', 'level-up']}
                                                                 className={classes.rotateIcon}/>
                                                <small className={classes.smallInfo}>{row.label}</small></>
                                            }
                                        </TableCell>
                                        {row.values.map((value, key) => (
                                            <TableCell align="left" classes={{root: classes.tableCell}}>
                                                {value.selected && <b>{value.selected}</b>}
                                                {value.wizard &&
                                                <small className={classes.smallInfo}>
                                                    <FontAwesomeIcon size="xs" icon={['fal', 'magic']}/> {value.wizard}
                                                </small>}
                                                {value.accepted > 0 && <span className="status-description"><span
                                                    className="status-icon status-8"></span> {value.accepted}</span>}
                                                {value.waiting > 0 && <span className="status-description"><span
                                                    className="status-icon status-7"></span> {value.waiting}</span>}
                                                {value.pending > 0 && <span className="status-description"><span
                                                    className="status-icon status-5"></span> {value.pending}</span>}
                                                {value.error > 0 && <span className="status-description"><span
                                                    className="status-icon status-2"></span> {value.error}</span>}
                                                {value.rejected > 0 && <span className="status-description"><span
                                                    className="status-icon status-1"></span> {value.rejected}</span>}
                                                {value.unprocessed > 0 && <span className="status-description"><span
                                                    className="status-icon status-2"></span> {value.unprocessed}</span>}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))
                            ))}
                            {data.revenue &&
                            <TableRow>
                                <TableCell>Liikevaihto</TableCell>
                                {data.revenue.map((value, key) => (
                                    <TableCell align="left" classes={{root: classes.tableCell}}><b>{value.value} €</b>
                                        <small
                                            className={classes.smallInfo}>{value.perVisitor} €</small></TableCell>
                                ))}
                            </TableRow>
                            }
                            {data.expense &&
                            <TableRow>
                                <TableCell>Kulut</TableCell>
                                {data.expense.map((value, key) => (
                                    <TableCell align="left" classes={{root: classes.tableCell}}><b>{value.value} €</b>
                                        <small
                                            className={classes.smallInfo}>{value.perVisitor} €</small></TableCell>
                                ))}
                            </TableRow>
                            }
                            {data.profit &&
                            <TableRow>
                                <TableCell classes={{root: classes.lastRowCell}}>Tulos</TableCell>
                                {data.profit.map((value, key) => (
                                    <TableCell align="left"
                                               classes={{root: classes.lastRowCell + ' ' + classes.tableCell}}><b>{value.value} €</b>
                                        <small
                                            className={classes.smallInfo}>{value.perVisitor} €</small></TableCell>
                                ))}
                            </TableRow>
                            }
                        </TableBody>
                    </Table>
                    }
                </Paper>
            </>
        );
    }
}

DashboardSegmentBehaviourTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DashboardSegmentBehaviourTable);
